import * as React from 'react';
import { useEffect } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { loadExternalScript } from '../../lib/utils';

const YT_ORIGIN = process.env.NODE_ENV === 'production' ? 'https://latori.com' : 'https://localhost:2022';

export default function BlogPostMediaVideo({ blok }) {
  const { video_id: videoId, video_host: videoHost } = blok;

  useEffect(() => {
    async function loadYouTubeIframeApi() {
      await loadExternalScript('https://www.youtube.com/iframe_api');
    }
    loadYouTubeIframeApi();
  }, []);

  const styles = clsx(
    'blok-blogpost-media-video my-5',
  );

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div className="aspect-[16/9] relative">
        {videoHost === 'youtube' && (
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            title={`YouTube Video ${videoId}`}
            src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&origin=${YT_ORIGIN}`}
            frameBorder="0"
            className="absolute w-full h-full"
          />
        )}
      </div>
    </div>
  );
}
